var _g, _rect, _rect2, _g2, _g3, _rect3, _path, _path2, _g4, _path3, _g5, _g6, _g7, _line, _g8, _g9, _g0, _g1, _g10, _g11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "basic",
    id: "Layer_1",
    width: 250,
    height: 60,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1745.66 467.66",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 198,
    display: "inline",
    fill: "none",
    width: 189,
    height: 225
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    d: "M256.66,210.74h18.41v141.6h61.83v15.58h-80.24V210.74z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 93.95,
    y: 279.3,
    display: "none",
    fill: "#1D71B8",
    width: 31.18,
    height: 177.52
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 136.86,
    y: 382.73,
    transform: "matrix(-2.680578e-07 -1 1 -2.680578e-07 -288.7861 593.6802)",
    display: "none",
    fill: "#1D71B8",
    width: 31.18,
    height: 117
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#888888",
    points: "400.27,124.29 391.77,146.83 275.77,159.03 284.27,136.48  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#818181",
    points: "284.27,136.48 275.77,159.03 258.24,129.97 266.74,107.42  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#818181",
    points: "482.51,260.69 474.01,283.23 391.77,146.83 400.27,124.29  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#888888",
    points: "519.67,256.78 511.17,279.33 474.01,283.23 482.51,260.69  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#969696",
    points: "419.91,91.32 519.67,256.78 482.51,260.69 400.27,124.29 284.27,136.48 266.74,107.42  "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#888888",
    points: "443.76,338.03 435.26,360.58 282.09,376.68 290.59,354.13  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#818181",
    points: "290.59,354.13 282.09,376.68 182.33,211.22 190.83,188.67  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#969696",
    points: "227.99,184.77 310.23,321.17 426.23,308.97 443.76,338.03 290.59,354.13 190.83,188.67  "
  }))))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    display: "none",
    fill: "#3C3C3B",
    width: 1746,
    height: 468
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.9867,
    y1: 236.2855,
    x2: 235.4991,
    y2: 236.2855
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D67858"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2119,
    style: {
      stopColor: "#DA8161"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5572,
    style: {
      stopColor: "#E39778"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991,
    style: {
      stopColor: "#F3BCA1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F3BDA2"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M167.15,289.16L167.15,289.16c-8.79-5.24-11.77-16.88-6.67-26.01l40.69-72.68 c5.11-9.13,16.38-12.28,25.17-7.05l0,0c8.79,5.24,11.77,16.88,6.67,26.01l-40.69,72.68C187.21,291.24,175.94,294.39,167.15,289.16z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.6313,
    y1: 272.9626,
    x2: 169.8822,
    y2: 272.9626
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D67858"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2137,
    style: {
      stopColor: "#DA8161"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5621,
    style: {
      stopColor: "#E39878"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F3BDA2"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M59.79,363.11L59.79,363.11c-8.79-5.24-11.77-16.88-6.67-26.01l82.42-147.25 c5.11-9.13,16.38-12.28,25.17-7.05l0,0c8.79,5.24,11.77,16.88,6.67,26.01L84.96,356.07C79.85,365.2,68.58,368.35,59.79,363.11z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#4688AE",
    points: "194.58,111.94 190.86,134.62 96.26,189.24 99.98,166.56  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#3A7392",
    points: "99.98,166.56 96.26,189.24 66.59,165.96 70.31,143.28  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#3A7392",
    points: "333.85,221.21 330.12,243.89 190.86,134.62 194.58,111.94  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#4688AE",
    points: "364.15,203.71 360.43,226.39 330.12,243.89 333.85,221.21  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#55A7D7",
    points: "195.22,71.16 364.15,203.71 333.85,221.21 194.58,111.94 99.98,166.56 70.31,143.28  "
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 221.0698,
    y1: 203.5603,
    x2: 341.3574,
    y2: 203.5603,
    gradientTransform: "matrix(0.9943 9.866891e-03 9.866891e-03 0.9829 1.4718 -2.5493)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D67858"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2137,
    style: {
      stopColor: "#DA8161"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5621,
    style: {
      stopColor: "#E39878"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F3BDA2"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M233.3,289.33L233.3,289.33c-8.79-5.23-11.87-16.71-6.88-25.63l81.51-145.73 c4.99-8.92,16.16-11.91,24.96-6.68l0,0c8.79,5.23,11.87,16.71,6.88,25.63l-81.51,145.73C253.26,291.57,242.09,294.56,233.3,289.33z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#4688AE",
    points: "332.08,302.71 328.35,325.39 203.44,397.51 207.16,374.83  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#3A7392",
    points: "207.16,374.83 203.44,397.51 34.5,264.96 38.23,242.28  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#55A7D7",
    points: "68.53,224.78 207.8,334.05 302.41,279.43 332.08,302.71 207.16,374.83 38.23,242.28  "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 459,
    y: 135,
    fill: "none",
    width: 693,
    height: 252
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M521.6,141.86h36.38l63.82,161.7h-39.08l-11.76-32.46h-62.23l-11.88,32.46h-39.2L521.6,141.86z M520.99,239 h37.85l-18.74-53.04h-0.37L520.99,239z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M716.37,354.52v-67.25c-0.65,1.72-2.41,4.1-5.27,7.17c-2.86,3.06-6.76,5.84-11.7,8.33 c-4.94,2.49-10.96,3.74-18.07,3.74c-9.72,0-18.21-2.39-25.48-7.17c-7.27-4.78-12.91-11.19-16.91-19.23c-4-8.04-6-16.97-6-26.77 c0-9.8,1.88-18.72,5.64-26.77c3.75-8.04,9.14-14.47,16.17-19.29c7.02-4.82,15.39-7.23,25.11-7.23c6.45,0,12.19,1,17.21,3 c5.02,2,9.15,4.37,12.37,7.1c3.22,2.74,5.41,5.25,6.55,7.53v-14.7h37.12v151.53H716.37z M692.36,277.22 c4.57,0,8.62-1.02,12.13-3.06c3.51-2.04,6.31-4.88,8.39-8.51c2.08-3.63,3.12-7.74,3.12-12.31c0-4.57-1.04-8.68-3.12-12.31 c-2.08-3.63-4.88-6.49-8.39-8.58c-3.51-2.08-7.55-3.12-12.13-3.12c-4.25,0-8.11,1.04-11.58,3.12c-3.47,2.08-6.23,4.94-8.27,8.58 c-2.04,3.63-3.06,7.74-3.06,12.31c0,4.57,1.02,8.68,3.06,12.31c2.04,3.63,4.8,6.47,8.27,8.51 C684.25,276.2,688.11,277.22,692.36,277.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M808.73,249.53c0,8,1.51,14.39,4.53,19.17c3.02,4.78,8.08,7.17,15.19,7.17c7.27,0,12.39-2.39,15.37-7.17 c2.98-4.78,4.47-11.17,4.47-19.17v-46.55h36.75v50.47c0,10.78-2.23,20.15-6.68,28.11c-4.45,7.96-10.88,14.11-19.29,18.44 c-8.41,4.33-18.62,6.49-30.62,6.49c-11.92,0-22.09-2.17-30.5-6.49c-8.41-4.33-14.82-10.47-19.23-18.44 c-4.41-7.96-6.62-17.33-6.62-28.11v-50.47h36.63V249.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M985.74,303.56v-16.29c-0.73,1.63-2.59,4-5.57,7.11c-2.98,3.1-6.92,5.9-11.82,8.39 c-4.9,2.49-10.62,3.74-17.15,3.74c-9.8,0-18.38-2.39-25.72-7.17c-7.35-4.78-13.07-11.19-17.15-19.23 c-4.08-8.04-6.12-16.97-6.12-26.77c0-9.8,2.04-18.72,6.12-26.77c4.08-8.04,9.8-14.47,17.15-19.29c7.35-4.82,15.92-7.23,25.72-7.23 c6.29,0,11.8,1,16.54,3c4.74,2,8.57,4.37,11.51,7.1c2.94,2.74,4.98,5.25,6.12,7.53v-14.7h37v100.57H985.74z M938.7,253.33 c0,4.57,1.06,8.68,3.19,12.31c2.12,3.63,4.96,6.47,8.51,8.51c3.55,2.04,7.49,3.06,11.82,3.06c4.49,0,8.45-1.02,11.88-3.06 c3.43-2.04,6.14-4.88,8.15-8.51c2-3.63,3-7.74,3-12.31c0-4.57-1-8.68-3-12.31c-2-3.63-4.72-6.49-8.15-8.58 c-3.43-2.08-7.39-3.12-11.88-3.12c-4.33,0-8.27,1.04-11.82,3.12s-6.39,4.94-8.51,8.58C939.76,244.66,938.7,248.76,938.7,253.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1080.07,303.56h-37.24V202.98h37.24v15.56h-0.61c0.65-1.88,2.25-4.27,4.78-7.17 c2.53-2.9,6.08-5.51,10.66-7.84c4.57-2.33,10.17-3.49,16.78-3.49c4.66,0,8.94,0.72,12.86,2.14c3.92,1.43,6.78,2.8,8.58,4.1 l-14.46,30.26c-1.14-1.39-3.17-2.84-6.06-4.35c-2.9-1.51-6.51-2.27-10.84-2.27c-4.98,0-9.09,1.27-12.31,3.8 c-3.23,2.53-5.59,5.6-7.1,9.19c-1.51,3.59-2.27,6.98-2.27,10.17V303.56z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1151.99,
    y: 144.4,
    fill: "none",
    width: 630.01,
    height: 220.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    d: "M1171.63,301.15c-2.79,0-4.18-1.39-4.18-4.18 V148.58c0-2.79,1.39-4.18,4.18-4.18h27.38c2.79,0,4.18,1.39,4.18,4.18v121.74h46.92c2.79,0,4.18,1.39,4.18,4.18v22.47 c0,2.79-1.39,4.18-4.18,4.18H1171.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    d: "M1346.78,301.15c-2.44,0-3.97-1.18-4.6-3.55 l-3.03-9.51c-7.87,10.31-18.85,15.47-32.92,15.47c-6.97,0-13.31-1.29-19.02-3.87c-5.71-2.58-10.42-6.62-14.11-12.12 c-3.69-5.5-5.54-12.02-5.54-19.54c0-11.5,4.18-20.39,12.54-26.7c8.36-6.3,18.98-9.46,31.87-9.46c7.25,0,14.63,1.05,22.15,3.14 v-5.64c0-6.2-1.92-10.73-5.75-13.58c-3.83-2.86-8.99-4.28-15.47-4.28c-8.22,0-17.59,2.06-28.11,6.17c-2.72,1.12-4.49,0.35-5.33-2.3 l-5.75-18.18c-0.84-2.65,0.07-4.39,2.72-5.23c13.38-4.32,26.44-6.48,39.19-6.48c7.25,0,13.85,0.78,19.8,2.35 c5.96,1.57,11.32,3.97,16.09,7.21c4.77,3.24,8.5,7.7,11.18,13.38c2.68,5.68,4.02,12.31,4.02,19.91v68.66 c0,2.79-1.39,4.18-4.18,4.18H1346.78z M1300.06,267.71c0,4.32,1.45,7.59,4.34,9.82c2.89,2.23,6.46,3.34,10.71,3.34 c2.16,0,4.29-0.35,6.38-1.04c2.09-0.7,4.13-1.78,6.11-3.24s3.57-3.57,4.75-6.32c1.18-2.75,1.78-5.94,1.78-9.56v-5.33 c-5.23-1.25-9.89-1.88-14-1.88c-5.99,0-10.83,1.15-14.53,3.45C1301.91,259.24,1300.06,262.83,1300.06,267.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    d: "M1462.77,303.55c-8.08,0-15.61-1.53-22.57-4.6 c-6.97-3.07-12.92-7.42-17.87-13.06l-3.76,11.7c-0.77,2.37-2.3,3.55-4.6,3.55h-15.78c-2.79,0-4.18-1.39-4.18-4.18l0.21-148.39 c0-2.79,1.39-4.18,4.18-4.18h24.24c2.79,0,4.18,1.39,4.18,4.18l-0.1,49.64c10.52-8.5,22.54-12.75,36.05-12.75 c10.66,0,20.34,2.65,29.05,7.94c8.71,5.29,15.48,12.45,20.33,21.47c4.84,9.02,7.26,18.9,7.26,29.63c0,10.73-2.42,20.6-7.26,29.63 c-4.84,9.02-11.62,16.18-20.33,21.48C1483.11,300.9,1473.43,303.55,1462.77,303.55z M1434.24,222.72 c-5.99,6.03-8.99,13.29-8.99,21.79c0,8.5,3,15.76,8.99,21.79c5.99,6.03,13.24,9.04,21.74,9.04c8.5,0,15.76-3.01,21.79-9.04 c6.03-6.03,9.04-13.29,9.04-21.79c0-8.5-3.01-15.76-9.04-21.79c-6.03-6.02-13.29-9.04-21.79-9.04 C1447.48,213.68,1440.23,216.69,1434.24,222.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    d: "M1577.72,303.55c-10.31,0-21.95-1.57-34.9-4.7 c-3.07-0.84-4.04-2.58-2.93-5.22l5.75-17.56c0.91-2.37,2.68-3.2,5.33-2.51c10.45,3.34,19.5,5.02,27.17,5.02 c8.57,0,12.85-2.82,12.85-8.46c0-1.18-0.51-2.32-1.52-3.4c-1.01-1.08-2.53-2.16-4.55-3.24c-2.02-1.08-4.08-2.09-6.17-3.03 s-4.7-2.09-7.84-3.45s-5.82-2.63-8.05-3.81c-3.48-1.81-6.52-3.62-9.09-5.43c-2.58-1.81-5.09-3.99-7.52-6.53 c-2.44-2.54-4.3-5.45-5.59-8.73c-1.29-3.27-1.93-6.86-1.93-10.76c0-6.27,1.2-11.79,3.61-16.56c2.4-4.77,5.64-8.55,9.72-11.34 c4.08-2.79,8.59-4.88,13.53-6.27c4.95-1.39,10.24-2.09,15.88-2.09c10.24,0,20.97,1.78,32.19,5.33c2.65,0.7,3.55,2.37,2.72,5.02 l-5.23,17.66c-0.77,2.79-2.54,3.69-5.33,2.72c-10.1-3.41-18.29-5.12-24.56-5.12c-6.83,0-10.24,2.19-10.24,6.58 c0,1.25,0.4,2.42,1.2,3.5c0.8,1.08,2.12,2.14,3.97,3.19c1.84,1.04,3.55,1.93,5.12,2.67c1.57,0.73,3.88,1.72,6.95,2.98 c3.06,1.25,5.47,2.26,7.21,3.03c3.97,1.74,7.4,3.5,10.29,5.28c2.89,1.78,5.8,4.01,8.73,6.69c2.93,2.68,5.17,5.87,6.74,9.56 c1.57,3.69,2.35,7.8,2.35,12.33c0,5.43-0.89,10.31-2.66,14.63c-1.78,4.32-4.13,7.84-7.05,10.55c-2.93,2.72-6.41,4.96-10.45,6.74 c-4.04,1.78-8.17,3.01-12.38,3.71C1586.83,303.2,1582.38,303.55,1577.72,303.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    d: "M1669.26,303.55c-5.71,0-10.61-2.04-14.68-6.11 s-6.11-8.97-6.11-14.68c0-5.64,2.04-10.54,6.11-14.68c4.08-4.14,8.97-6.22,14.68-6.22c5.78,0,10.71,2.06,14.79,6.17 c4.08,4.11,6.11,9.02,6.11,14.73c0,5.85-2.04,10.78-6.11,14.79C1679.97,301.55,1675.04,303.55,1669.26,303.55z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    opacity: 0.4,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 414,
    y1: 117,
    x2: 414,
    y2: 342
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c5803b6711008a30a8eedcc663d6fa1f.svg";
export { ForwardRef as ReactComponent };